<template>
  <v-container>

   <v-layout mb-1>
        <v-flex xs12>
          <h2 class="white--text">NCE Reports </h2>
        </v-flex>
      </v-layout>
      <v-layout>
            <v-flex xs3>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <v-col cols="12" md="2" class="text-lg-right">
        <v-menu offset-y >
<!--            <template v-slot:activator="{ on }">-->
<!--              <v-btn-->
<!--                color="secondary"-->
<!--                dark-->
<!--                v-on="on"-->
<!--                class="mb-3"-->
<!--                @click="exportToExcel"-->
<!--              >-->
<!--                Export Report-->
<!--              </v-btn>-->
<!--            </template>-->
        </v-menu>
      </v-col>
          </v-layout>
    <v-layout row wrap ml-3 class="bg-white">
      <v-flex>
      <div class="aarrow_box">
  <v-card class="mt-3">
    <v-layout>
      <v-flex xs3>
        <span class="accent--text" style="font-size: 14px; font-weight:700;"> Unbulking Tracing Report </span>
        <v-spacer v-if="userId"></v-spacer>
      </v-flex>
      <v-spacer>
      </v-spacer>
      <v-flex xs3>
        <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
      </v-flex>
      <v-spacer>
      </v-spacer>
      <v-flex xs3>
        <v-text-field label="Search" v-model="search">
        </v-text-field>
      </v-flex>
    </v-layout>
  <table class="table table-responsive">
    <v-card-text>
    <thead class="thead">
      <tr>
              <th scope="col">Sale Number</th>
              <th scope="col">E-slip Number</th>
              <th scope="col">Status Name</th>
              <th scope="col">Invoice ID</th>
              <th scope="col">Invoice Status</th>
              <th scope="col">Lot Number</th>
              <th scope="col">Invoice Amount</th>
              <th scope="col">DI Sale Number</th>
              <th scope="col">Season</th>
              <th scope="col">Total Weight</th>
              <th scope="col">Grade</th>
              <th scope="col">Number Of Bags</th>
              <th scope="col">Price</th>
              <th scope="col">Weight Bought</th>
              <th scope="col">Clean Coffee outturn</th>
              <th scope="col">Parchment Outturn</th>
              <th scope="col">Grower Outturn Number</th>
              <th scope="col">Grade</th>
              <th scope="col">Commodity</th>
              <th scope="col">Weight</th>
              <th scope="col">Grower Name</th>
              <th scope="col">Grower Code</th>
              <th scope="col">Non-checkoff Account</th>
              <th scope="col">Checkoff Account</th>
              <th scope="col">Broker Code</th>
              <th scope="col">Broker Name</th>
              <th scope="col"  style="white-space:nowrap;">Broker Account</th>
               <th scope="col">Grower Gross Amount</th>
              <th scope="col">Broker Charge Rate</th>

            </tr>
    </thead>
    <tbody class="ml-2">

      <tr v-for="row in paginatedData" :key="row.id">
        <td>{{ row.saleNumber }}</td>
		<td>{{ row.eslipNumber }}</td>
        <td>{{ row.statusName }}</td>
        <td>{{ row.invoiceId}}</td>
        <td>{{ row.invoiceStatus }}</td>
        <td>{{ row.lotNumber }}</td>
        <td>{{ row.invoiceAmount }}</td>
        <td>{{ row.diSaleNumber }}</td>
        <td>{{ row.season }}</td>
        <td>{{ row.totalWeight }}</td>
        <td>{{ row.grade }}</td>
        <td>{{ row.numberOfBags }}</td>
        <td>{{ row.price }}</td>
        <td>{{ row.weightBought }}</td>
        <td>{{ row.cleanCoffeeOutturn }}</td>
        <td>{{ row.parchmentOutturn }}</td>
        <td>{{ row.growerOutturn }}</td>
        <td>{{ row.ccdGrade }}</td>
        <td>{{ row.commodity }}</td>
        <td>{{ row.pdWeight }}</td>
        <td>{{ row.organisationName }}</td>
        <td>{{ row.growerCode }}</td>
        <td>{{ row.nonCheckoffAccount }}</td>
        <td>{{ row.checkoffAccount }}</td>
        <td>{{ row.brokerCode }}</td>
        <td>{{ row.brokerName }}</td>
        <td  style="white-space:nowrap;">{{ row.brokerAccount }}</td>
        <td>{{ row.brokerChargeRate }}</td>
      </tr>
    </tbody>
  </v-card-text>
  </table>
  <div>
      <v-btn @click="prevPage" :disabled="currentPage === 1" > {{ prev }}  Previous</v-btn>
      <span class="ml-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <v-btn @click="nextPage" :disabled="currentPage === totalPages"><span class="ml-2">Next </span> {{ next }}</v-btn>
    </div>

</v-card>
</div>
</v-flex>
    </v-layout>

  </v-container>
  </template>

<script>
import axios from 'axios'
import config from '../../../config'
import * as XLSX from 'xlsx'

export default {
	name: 'PaidUnpaidData',
	data: function () {
		return {
			items: [],
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 5,
			page: 1,
			prev: '<<',
			next: '>>',
			payments: [],
			currentPage: 1,
			itemsPerPage: 10,
			// totalData: 100,
			totalItems: 1
		}
	},

	computed: {
		totalPages () {
			return Math.ceil(this.totalItems / this.itemsPerPage)
		},
		paginatedData () {
			const startIndex = (this.currentPage - 1) * this.itemsPerPage
			const endIndex = startIndex + this.itemsPerPage
			return this.payments.slice(startIndex, endIndex)
		}
	},

	mounted () {
		this.getDataFromApi()
		this.getSettlementGrowersDetails()
	},

	methods: {
		getDataFromApi () {
			this.loading = true
			return new Promise((resolve, reject) => {
				const items = this.getAuctionFiles()
				const total = items.length
				setTimeout(() => {
					this.loading = false
					resolve({
						items,
						total
					})
				}, 1000)
			})
		},
		getAuctionFiles () {
			var url = config.serverURI + "/upload/auction/getAll";
			axios.get(url)
				.then(response => {
					this.items = response.data
					this.$emit('updateAuctionFilesCount', this.items.length)
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.items
		},
		prevPage () {
			if (this.currentPage > 1) {
				this.currentPage--
			}
		},
		nextPage () {
			if (this.currentPage < this.totalPages) {
				this.currentPage++
			}
		},
		getSettlementGrowersDetails () {
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			const allPayments = config.serverURI + '/reports/unbulkingexceptions'
			const withSettlementDetails = axios.post(allPayments)
			axios
				.all([withSettlementDetails])
				.then(
					axios.spread((...responses) => {
						const responsewithDet = responses[0]
						const arr = responsewithDet.data
						this.totalItems = parseInt(Object.keys(responsewithDet.data).length)
						this.payments = arr
						return arr
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		},
		exportToExcel () {
			const exportData = this.payments.map(transaction => ({
				saleNumber: transaction.saleNumber,
				eslipNumber: transaction.eslipNumber,
				statusName: transaction.statusName,
				'invoice Number': transaction.invoiceId,
				invoiceStatus: transaction.invoiceStatus,
				lotNumber: transaction.lotNumber,
				invoiceAmount: transaction.invoiceAmount,
				diSaleNumber: transaction.diSaleNumber,
				season: transaction.season,
				totalWeight: transaction.totalWeight,
				grade: transaction.grade,
				numberOfBags: transaction.numberOfBags,
				price: transaction.price,
				weightBought: transaction.weightBought,
				cleanCoffeeOutturn: transaction.cleanCoffeeOutturn,
				parchmentOutturn: transaction.parchmentOutturn,
				ccgrade: transaction.ccdGrade,
				commodity: transaction.commodity,
				ccWeight: transaction.ccdWeight,
				ccdWeight: transaction.ccdWeight,
				pdWeight: transaction.pdWeight,
				organisationName: transaction.organisationName,
				growerCode: transaction.growerCode,
				societyName: transaction.societyName,
				nonCheckoffAccount: transaction.nonCheckoffAccount,
				checkoffAccount: transaction.checkoffAccount,
				brokerCode: transaction.brokerCode,
				brokerName: transaction.brokerName,
				brokerAccount: transaction.brokerAccount,
				brokerChargeRate: transaction.brokerChargeRate
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'UnbulkingData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'unbulking_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		}
	}
}
</script>
  <style>
  table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  overflow: hidden;
}

thead {
  background-color: #E5E5E5;
}

tr:nth-child(even) {
  background-color: #F2F2F2;
}

th,
td {
  padding: 15px;
  text-align: center;
}

@media(max-width: 800px) {
  table {
    border: 0;
  }
  thead {
    display: none;
  }
  tr {
    display: block;
    margin: 0 0 20px 0;
  }
  td {
    display: block;
    text-align: right;
  }
  td:before {
    content: attr(aria-label);
    float: left;
    font-weight: bold;
  }
  td:last-child {
    border-bottom: 0;
  }
  tr:nth-child(odd) {
    background-color: #F2F2F2;
  }
  tr:nth-child(even) {
    background-color: #FFFFFF;
    border-width: 3px 0 3px 0;
    border-style: solid;
    border-color: #E5E5E5;
  }
}
  </style>
